import { StylesConfig } from 'react-select';
import { when } from '@execonline-inc/maybe-adapter';
import { FilterOption } from './UseParticipantDynamicTypeaheadSelect/Types';

const textColor = (isSelected: boolean, isDisabled: boolean): 'gray' | 'black' | undefined => {
  if (isDisabled) {
    return 'gray';
  } else if (!isSelected) {
    return 'black';
  }
  return undefined;
};

const borderColor = (isFocused: boolean, valid: boolean) =>
  when(isFocused, '#187A90')
    .orElse(() => when(valid, '#BEC0C5'))
    .getOrElseValue('red');

export const createStylesConfig = (valid: boolean): StylesConfig<FilterOption> => ({
  control: (baseStyles, state) => ({
    ...baseStyles,
    fontSize: '0.875rem',
    fontWeight: '500',
    borderColor: borderColor(state.isFocused, valid),
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    '&:hover': {
      borderColor: borderColor(state.isFocused, valid),
    },
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    backgroundColor: isFocused ? '#187a904d' : 'white',
    color: textColor(isSelected, isDisabled),
    fontSize: '0.875rem',
    fontWeight: '500',
    zIndex: 100,
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 100,
    maxHeight: 'calc(100vh - 350px)',
    '@media (min-width: 401px) and (max-width: 768px)': {
      maxHeight: 'calc(100vh - 650px)',
    },
    '@media (max-width: 400px)': {
      maxHeight: 'calc(100vh - 600px)',
    },
    overflow: 'hidden',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 100 }),
  input: (base) => ({
    ...base,
    'input:focus': {
      boxShadow: 'none',
    },
  }),
});
